import Icon from '../components/Icon.vue'

Icon.register({"child":{"width":1280,"height":1792,"paths":[{"d":"M1188 548l-292 292v824q0 46-33 79t-79 33-79-33-33-79v-384h-64v384q0 46-33 79t-79 33-79-33-33-79v-824l-292-292q-28-28-28-68t28-68q29-28 68.5-28t67.5 28l228 228h368l228-228q28-28 68-28t68 28q28 29 28 68.5t-28 67.5zM864 384q0 93-65.5 158.5t-158.5 65.5-158.5-65.5-65.5-158.5 65.5-158.5 158.5-65.5 158.5 65.5 65.5 158.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/child.js
// module id = wKr2
// module chunks = 0